import {
  TSU_REL_DEPOSIT_DATA_CLEAR,
  TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST,
  TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST,
  TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST,
  TSU_REL_DEPOSIT_DATA_SORT,
  TSU_REL_DEPOSIT_DATA_TOGGLE_COLUMN,
  TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST,
} from './tsunamiRelatedDepositsReducer';

export const clearPageData = () => ({ type: TSU_REL_DEPOSIT_DATA_CLEAR });
export const getTsunami = ({ id }) => ({ type: TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST, id });
export const getDeposits = ({ id }) => ({ type: TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST, id });
export const deleteDeposit = ({ id }) => ({ type: TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST, id });
export const toggleColumns = visibleColumns => ({ type: TSU_REL_DEPOSIT_DATA_TOGGLE_COLUMN, visibleColumns });
export const sortData = sort => ({ type: TSU_REL_DEPOSIT_DATA_SORT, sort });
export const getPublications = () => ({ type: TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST });
export const getGeologicAges = () => ({ type: TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST });
